import Stack from '@mui/material/Stack';
import { GameParams } from '../../features/index.ts';
import { JuicyTypography } from '../../components/index.ts';
import { Typography, useTheme } from '@mui/material';
import { NextPageButton } from '../../components/button/NextPageButton.tsx';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { Path } from '../../assets/enums/index.ts';
import { innerWrapperSx, wrapperSx } from './styles.ts';
import { Button } from '../../components/button/index.ts';

export const PostGamePage = () => {

  const { palette } = useTheme();

  const { clearGameSessionContext, setParams } = useGameSessionContext();

  const nav = useNavigate();

  const onPlayAgainClick = useCallback(() => {
    setParams({ amountWithDiscount: undefined });
    nav(Path.GameSettings);
  }, [setParams, nav]);

  const onFinishClick = useCallback(() => {
    clearGameSessionContext();
    nav(Path.Home);
  }, [clearGameSessionContext, nav]);

  return (
    <Stack height={'100%'} py={14}>

      <JuicyTypography mb={4}>Not a Winner On This Shot — But Great Effort!</JuicyTypography>
      <Typography variant={'subtitle'} color={palette.white_90} mb={10.5}>Check your phone — we’ve sent a link to watch
        your shot replay in the Moneyball Golf app</Typography>

      <Stack sx={wrapperSx}>
        <Stack sx={innerWrapperSx}>
          <Typography variant={'subtitle'}>The video will be here</Typography>
        </Stack>
        <GameParams />
      </Stack>

      <Stack width="100%" mt="auto" direction={'row'} alignItems={'center'} gap={8}>
        <Button sx={{ color: palette.warm_black }} variantStyle={'secondary'} onClick={onFinishClick}>finish</Button>
        <NextPageButton onClick={onPlayAgainClick}>Play again</NextPageButton>
      </Stack>

    </Stack>
  );
};
